<ng-container *ngTemplateOutlet="mode() === 'home' ? homefilter : nohomefilter"></ng-container>

<ng-template #homefilter>
    @switch (mediaService.media()) {
    @case ('xs') {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    @case ('sm') {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    @case ('md') {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    @default {
    <ng-container *ngTemplateOutlet="homefilterdesk"></ng-container>
    }
    }
</ng-template>

<ng-template #nohomefilter>
    @switch (mode()) {
    @case ('nohomesmall') {
    {{zielText()}}
    }
    @default {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    }
</ng-template>
<!-- <ng-template #mbfilters>
    <button class="tmpbtn w100" #mdbuttonMobile="cdkOverlayOrigin" cdkOverlayOrigin (click)="openModalMobile()"
        matRipple>
        <span>{{zielText()}}</span>
    </button>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttonMobile"
        [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal()"
        [cdkConnectedOverlayHasBackdrop]="true">
        <ng-container *ngTemplateOutlet="modal"></ng-container>
    </ng-template>
</ng-template> -->


<ng-template #homemodeMobile>
    <div class="searchBoxWrapper_mobile customflex" #mdbuttondesk="cdkOverlayOrigin"
        [class.searchBoxWrapperactive]="showModal()" cdkOverlayOrigin (click)="openModal()" ng-clickOutside
        (clickOutside)="closeModal()">
        <div class="wrapper">
            <span class="description">{{title()}}</span>
            <div class="searchinputwrapper">
                <input type="text" placeholder="{{showModal() ? '': zielText()}}" [class.inputactive]="showModal()"
                    [formControl]="mySearchControl" ng-focus [appAutoFocus]="focus()" class="searchinput">
                @if(mySearchControl?.value?.length > 0) {
                <button (click)="clearText()" class="closesection">
                    <img src="../../../../assets/tvg/close.svg" alt="close">
                </button>
                }
            </div>
        </div>
        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttondesk"
            [cdkConnectedOverlayPositions]="overlaypos" [cdkConnectedOverlayOpen]="showModal()"
            [cdkConnectedOverlayHasBackdrop]="false" (backdropClick)="closeModal()">
            <ng-container *ngTemplateOutlet="modal"></ng-container>
        </ng-template>
    </div>
</ng-template>

<ng-template #homefilterdesk>
    <!-- <button class="tmpbtn w100" 
         
       
         #mdbuttondesk="cdkOverlayOrigin" cdkOverlayOrigin
        (click)="openModal($event)" matRipple>
        <ng-container *ngTemplateOutlet="iconn"></ng-container>
        <span>{{zielText}}</span>
    </button> -->

    <div class="searchBoxWrapper w100" #mdbuttondesk="cdkOverlayOrigin" [class.searchBoxWrapperactive]="showModal()"
        cdkOverlayOrigin (click)="openModal()" ng-clickOutside (clickOutside)="closeModal()">
        <div class="wrapper">
            <span class="description">{{title()}}</span>
            <div class="searchinputwrapper">
                <input type="text" placeholder="{{showModal() ? '': zielText()}}" [class.inputactive]="showModal()"
                    [formControl]="mySearchControl" ng-focus [appAutoFocus]="focus()" class="searchinput">
                @if(mySearchControl?.value?.length > 0) {
                <button (click)="clearText()" class="customsize">
                    <img src="../../../../assets/tvg/close.svg" alt="close">
                </button>
                }
            </div>
        </div>
        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttondesk"
            [cdkConnectedOverlayPositions]="overlaypos" [cdkConnectedOverlayOpen]="showModal()"
            [cdkConnectedOverlayHasBackdrop]="false" (backdropClick)="closeModal()">
            <ng-container *ngTemplateOutlet="modal"></ng-container>
        </ng-template>
    </div>
</ng-template>


<ng-template #modal>
    @switch (mediaService.media()) {
    @case ('xs') {
    <ng-container *ngTemplateOutlet="mobileModal"></ng-container>
    }
    @case ('sm') {
    <ng-container *ngTemplateOutlet="mobileModal"></ng-container>
    }
    @default {
    <ng-container *ngTemplateOutlet="mobileDesk"></ng-container>
    }
    }
</ng-template>


<ng-template #mobileDesk>
    <div class="custompopupwrapper mat-elevation-z1">
        <div class="popupbody">
            <ng-container *ngTemplateOutlet="datassection"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #mobileModal>
    <div class="backdropwrapper-mobile">
        <div class="filterwrapper-mobile">
            <button class="shettheader" (click)="closeModal()" #searchheader>
                <img src="../../../../../assets/tvg/leftdirection.svg" alt="goback icon">
                <span>{{title()}}?</span>
            </button>
            <div class="searchBoxWrapper customflex" #mdbuttondesk="cdkOverlayOrigin"
                [class.searchBoxWrapperactive]="showModal()" cdkOverlayOrigin (click)="openModal()" ng-clickOutside
                (clickOutside)="closeModal()">
                <div class="wrapper" (click)="$event.stopPropagation()">
                    <span class="description">{{title()}}</span>
                    <div class="searchinputwrapper">
                        <input type="text" placeholder="{{showModal() ? '': zielText()}}"
                            [class.inputactive]="showModal()" [formControl]="mySearchControl" ng-focus
                            [appAutoFocus]="focus()" class="searchinput">
                        @if(mySearchControl?.value?.length > 0) {
                        <button (click)="clearText()" class="closesection">
                            <img src="../../../../assets/tvg/close.svg" alt="close">
                        </button>
                        }
                    </div>
                </div>
            </div>
            <div class="custompopupwrapper-mobile">
                <div class="popupbody">
                    <ng-container *ngTemplateOutlet="datassection"></ng-container>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #datassection>
    <div class="customscrolls" [class.f-bodywrapper]="mediaService.deskmode()"
        [class.f-bodywrapper-mobile]="!mediaService.deskmode()" (click)="$event.stopPropagation()">
        @if(selectedList()?.length > 0) {
        <div class="selected-wrapper">
            <button class="selected-item-alle" (click)="removeAllSelected()">
                <span>{{'Alles löschen'}}</span>
            </button>
            @for (item of selectedList(); let k = $index; track k) {
            <div class="selected-item">
                <span>{{item.name}} <span class="second-item-line">{{item.code}}</span></span>
                <button (click)="removeFromSelected(k)">
                    <mat-icon class="clearbtn">clear</mat-icon>
                </button>
            </div>
            }
        </div>
        }
        @if((searchObj | async); as zimmer) {
        @for (item of zimmer; track $index) {
        @if(isNotInlist(item)) {
        <button class="item-wrapper" (click)="selectValue(item)">
            <div class="item-body">
                <span class="first-item-line">{{item.name}} <span class="second-item-line">{{item.code}}</span></span>
            </div>
        </button>
        }
        }
        } @else {
        <div class="customchipwrapper">
            @if(selectedList()?.length > 0) {
            <button class="custopmchip" (click)="removeAllSelected()">
                <span>beliebig</span>
            </button>
            } @else {
            <button class="custopmchip_active" (click)="removeAllSelected()">
                <img src="../../../../assets/tvg/checked.svg" alt="checked">
                <span>beliebig</span>
            </button>
            }
        </div>
        <!-- <div class="searchresbody">
            <div class="titlewrp">
                <span class="stattitle">Beliebte Zimmer</span>
            </div>
            <div class="customchipwrapper">
                @for (item of beliebig_zimmer; track $index) {
                @if(isNotInlist(item)) {
                <button class="custopmchip" (click)="addZimmer($event, item)">
                    <span>{{item.name}} ({{item.code}})</span>
                </button>
                } @else {
                <button class="custopmchip_active" (click)="addZimmer($event, item)">
                    <img src="../../../../assets/tvg/checked.svg" alt="checked">
                    <span>{{item.name}} ({{item.code}})</span>
                </button>
                }
                }

            </div>
        </div> -->
        }
    </div>
    <div class="ubwrapper">
        <button class="custombutton customunfilled w100" (click)="take()">Übernehmen {{selectedList()?.length > 0 ? '('
            +
            selectedList().length + ')' : ''}}</button>
    </div>
</ng-template>


<!-- <ng-template #iconn>
    <ng-container [ngSwitch]="icon">
        <ng-container *ngSwitchCase="'directions_boat'" [ngTemplateOutlet]="directions_boat1"></ng-container>
        <ng-container *ngSwitchCase="'verified'" [ngTemplateOutlet]="verified1"></ng-container>
        <ng-container *ngSwitchCase="'place'" [ngTemplateOutlet]="place1"></ng-container>
        <ng-container *ngSwitchCase="'timelapse'" [ngTemplateOutlet]="timelapse1"></ng-container>
        <ng-container *ngSwitchCase="'people_alt'" [ngTemplateOutlet]="people_alt1"></ng-container>
        <ng-container *ngSwitchCase="'flight'" [ngTemplateOutlet]="flight1"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="houseboat1"></ng-container>
    </ng-container>
</ng-template> -->

<!-- <ng-template #flight1>
    <mat-icon fontIcon="flight"></mat-icon>
</ng-template>

<ng-template #people_alt1>
    <mat-icon fontIcon="people_alt"></mat-icon>
</ng-template>

<ng-template #directions_boat1>
    <mat-icon fontIcon="directions_boat"></mat-icon>
</ng-template>

<ng-template #verified1>
    <mat-icon fontIcon="verified"></mat-icon>
</ng-template>

<ng-template #place1>
    <mat-icon fontIcon="place"></mat-icon>
</ng-template>

<ng-template #timelapse1>
    <mat-icon fontIcon="timelapse"></mat-icon>
</ng-template>

<ng-template #houseboat1>
    <mat-icon fontIcon="houseboat"></mat-icon>
</ng-template> -->